import React from "react";
import { Route, Routes } from "react-router-dom";
import Auth from "./containers/Auth";
import Groups from "./moduls/groups/Groups";
import Home from "./containers/Home";
import Products from "./moduls/products/Products";
import Orders from "./moduls/purchase_orders/ordercreate/Orders";
import OrdersCreate from "./moduls/purchase_orders/ordercreate/OrdersCreate";
import OrderAssign from "./moduls/purchase_orders/ordercreate/OrderAssign";
import OrderEnter from "./moduls/purchase_orders/orderenter/OrderEnter";
import OrdersListenter from "./moduls/purchase_orders/orderenter/OrdersListenter";
import Loan from "./moduls/loans routes/Loan";
import LoanCreate from "./moduls/loans routes/loancreate/LoanCreate";
import Loanrepay from "./moduls/loans routes/loancreate/Loanrepay";
import Factura from "./moduls/facturacions/Factura";
import Sellers from "./moduls/users/Sellers";
import Roles from "./moduls/permisions/Roles";
import Permisions from "./moduls/permisions/Permisions";
import Traslados from "./moduls/traslados/Traslados";
import Nuevotraslado from "./moduls/traslados/Nuevotraslado";
import Aceptartraslado from "./moduls/traslados/Aceptartraslado";
import VisualizarFactura from "./moduls/facturacions/VisualizarFactura";
import CambioSerial from "./moduls/cambioserialenfactura/CambioSerial";
import Devolverfactura from "./moduls/devolverfactura/Devolverfactura";
import Portabilidadpdf from "./moduls/postabilidades/Portabilidadpdf";
import Portabilidadpdfpos from "./moduls/postabilidadespos/Portabilidadpdf";
import Listaexportados from "./moduls/postabilidades/Listaexportados";
import Reporteportabilidades from "./moduls/postabilidades/Reporteportabilidades";
import Rutas from "./moduls/rutas/Rutas";
import Circuitos from "./moduls/circuitos/Circuitos";
import Vendedores from "./moduls/rutas/components/Vendedores";
import Clients from "./moduls/clientes/Clients";
import Clientsp from "./moduls/clientesPromotores/Clientsp";
import Reporte from "./moduls/reportegestionrutas/Reporte";
import Reportechart from "./moduls/reportegestionrutas/Reportechart";
import Reportetree from "./moduls/reportegestionrutas/components/Reportetree";
import Reporteclient from "./moduls/reportegestionrutas/Reporteclient";
//import Reporteportabilidades
import ReportePromotores from "./moduls/postabilidades/Reporte_promotores";
import ReporteTropas from "./moduls/postabilidades/Reporte_tropas";
//import Reporteportabilidadespos
import ReportePromotoresPos from "./moduls/postabilidadespos/Reporte_promotores";
import ReporteTropasPos from "./moduls/postabilidadespos/Reporte_tropas";

import PortabilidadesPos from "./moduls/postabilidadespos/Reporteportabilidades";
import Encuesta from "./moduls/encuestas/containers/Encuesta";
import VerEncuesta from "./moduls/encuestas/containers/VerEncuesta";
import Respuestas from "./moduls/encuestas/containers/Respuestas";

import Reportemaps from "./moduls/reportegestionrutas/Reportemaps";
import MenuCrud from "./moduls/menu/Menu";
import BodegasCrud from "./moduls/bodegas/Bodegas";
import SerialTable from "./moduls/seriales/Seriales";
import Chips from "./moduls/chips/Chips";
import TroopLoan from "./moduls/troop_loans/TroopLoan";
import TroopLoansCreate from "./moduls/troop_loans/common/TroopLoansCreate";
import TroopLoansRepay from "./moduls/troop_loans/common/TroopLoansRepay";
import ListFactura from "./moduls/listFactura/ListFactura";
import Descuentos from "./moduls/descuentos";
import Liquidaciones from "./moduls/liquidaciones/Liquidaciones";
import LiquidacionesVendedor from "./moduls/liquidaciones-vendedor/Liquidaciones-vendedor";
import LiquidacionList from "./moduls/reporte-liquidaciones";
import ReporteVendedores from "./moduls/reportes-vendedor";

import RecorridoGestion from "./moduls/recorrido-gestion";
import VerificarEncuestas from "./moduls/verificarEncuestas";

function Routers(props) {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Auth />} />
      <Route path="/groups" element={<Groups />} />
      <Route path="/products" element={<Products />} />
      <Route path="/orders_create" element={<OrdersCreate />} />
      <Route path="/orders" element={<Orders />} />
      <Route path="/order_assign/:order_id" element={<OrderAssign />} />
      <Route path="/order_enter/:order_id" element={<OrderEnter />} />
      <Route path="/order_list" element={<OrdersListenter />} />
      <Route path="/loans-routes" element={<Loan />} />
      <Route path="/loans_create" element={<LoanCreate />} />
      <Route path="/loan_repay" element={<Loanrepay />} />
      <Route path="/factura_prestamos" element={<Factura />} />
      <Route path="/sellers" element={<Sellers />} />
      <Route path="/roles" element={<Roles />} />
      <Route path="/permisions" element={<Permisions />} />
      <Route path="/traslados" element={<Traslados />} />
      <Route path="/nuevo-traslado" element={<Nuevotraslado />} />
      <Route path="/aceptar-traslado" element={<Aceptartraslado />} />
      <Route path="/visualizarfactura" element={<VisualizarFactura />} />
      <Route path="/cambioserial" element={<CambioSerial />} />
      <Route path="/portabilidadpdf" element={<Portabilidadpdf />} />
      <Route path="/portabilidadpdfpos" element={<Portabilidadpdfpos />} />
      <Route path="/devoluciondefactura" element={<Devolverfactura />} />
      <Route path="/listaexportador" element={<Listaexportados />} />
      <Route path="/clientes" element={<Clients />} />
      <Route path="/rutas" element={<Rutas />} />
      <Route path="/clientes_promotores" element={<Clientsp />} />
      <Route path="/circuito/:idruta/:nombreruta" element={<Circuitos />} />
      <Route path="/vendedores/:idruta/:nombreruta" element={<Vendedores />} />
      <Route path="/reporte_rutas" element={<Reporte />} />
      <Route path="/reporte_rutas_chart" element={<Reportechart />} />
      <Route path="/reporte_tree" element={<Reportetree />} />
      <Route path="/reporte_client" element={<Reporteclient />} />
      <Route path="/reporte_promotores" element={<ReportePromotores />} />
      <Route path="/reporte_tropas" element={<ReporteTropas />} />
      <Route path="/encuestas" element={<Encuesta />} />
      <Route path="/reporte_vendedores" element={<ReporteVendedores />} />
      <Route path="/encuesta/:id" element={<VerEncuesta />} />
      <Route path="/respuestas/:id" element={<Respuestas />} />
      <Route path="/reporte_maps" element={<Reportemaps />} />
      <Route path="/menus" element={<MenuCrud />} />
      <Route path="/bodegas" element={<BodegasCrud />} />
      <Route path="/seriales" element={<SerialTable />} />
      <Route path="/chips" element={<Chips />} />
      <Route path="/troop-loans" element={<TroopLoan />} />
      <Route path="/troop-loans_create" element={<TroopLoansCreate />} />
      <Route path="/troop-loans_repay" element={<TroopLoansRepay />} />
      <Route path="/list-factura" element={<ListFactura />} />
      <Route path="/descuentos" element={<Descuentos />} />
      <Route path="/liquidaciones" element={<Liquidaciones />} />
      <Route
        path="/liquidaciones-vendedor"
        element={<LiquidacionesVendedor />}
      />
      <Route path="/reporte-liquidaciones" element={<LiquidacionList />} />
      <Route
        path="/reporte-portabilidades"
        element={<Reporteportabilidades />}
      />
      <Route
        path="/portabilidadespos_promotores"
        element={<ReportePromotoresPos />}
      />
      <Route path="/portabilidadespos_tropas" element={<ReporteTropasPos />} />
      <Route path="/verificar_encuestas" element={<VerificarEncuestas />} />
      <Route
        path="/reporte-portabilidadespos"
        element={<PortabilidadesPos />}
      />
      <Route path="/recorrido-gestion" element={<RecorridoGestion />} />
    </Routes>
  );
}

export default Routers;
